import type { IconData } from '@stacksjs/iconify-core'

export const emailMailboxClose: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 9.14h1.53v12.19h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M3.805 22.86h9.14V32h1.53v-9.14h4.57V32h1.52v-9.14h7.62v-1.53h-13.71V9.14h-1.53V7.62h6.1v4.57h1.52V7.62h6.1V6.09h-6.1V4.57h4.57V0h-6.09v6.09H5.325v1.53h-1.52v1.52h-1.52v12.19h1.52Zm16.76-21.34h3.05v1.53h-3.05Zm-16.76 9.14h1.52V9.14h3.05v1.52h-3.05v7.62h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailMailboxClose
